(function () {
  // Cowalkies PDP gallery: dot sync + click-and-drag for desktop mouse users.
  //
  // The gallery track itself is Dawn's own <slider-component> (assets/global.js) — untouched —
  // just switched on at every breakpoint instead of only mobile (see the .ai-pdp-gallery-*
  // overrides in sections/main-product.liquid). SliderComponent already recomputes
  // `currentPage` from the container's own `scroll` event and dispatches a `slideChanged`
  // CustomEvent on every change, including a variant-swap's programmatic scrollTo — so dots stay
  // correct for free without a second observer duplicating that bookkeeping.
  document.querySelectorAll('.product__media-wrapper slider-component').forEach(setUpGallery);
  suppressAutoScrollToMedia();
  suppressFocusScrollOnVariantChange();
  setUpNotifyDebounce();
  setUpAccordions();
  syncMediaHeightToInfoColumn();
  setUpColorGallerySync();

  // Color-gallery override (snippets/product-media-gallery.liquid's color_gallery_images branch,
  // fed by the custom.color_gallery variant metafield) uses plain metafield images, not real
  // Shopify media — so there's no real featured_media.id for product-info.js's own updateMedia()
  // to match slides by, and it bails out (`if (!variantFeaturedMediaId) return;`) doing nothing
  // at all on every color swap. The server already re-renders the right images for the newly
  // selected color on every variant-swap fetch (color_gallery_images is recomputed fresh each
  // request from product.selected_or_first_available_variant) — this just has to get that already-
  // correct markup into the live DOM, wholesale, since there's no stable per-image id to reorder
  // by the way the native path does for products with real photos.
  //
  // The zoom modal (snippets/product-media-modal.liquid, #ProductModal-<id>) needs the exact
  // same treatment, and for the exact same reason — real bug reported live: switch color, open
  // the zoom, still see the old color's photos. product-info.js's variant-swap fetch response
  // already contains a freshly re-rendered modal too (it's part of the same "main" section), it
  // just was never being read. `<product-modal>`'s own connectedCallback (assets/global.js)
  // relocates it to a direct child of <body> on insert — harmless to swap via `outerHTML`
  // (ids still resolve it via `document.getElementById` regardless of DOM position), and the
  // replacement re-fires that same connectedCallback (plus assets/product-modal.js's own
  // constructor, so its drag/zoom listeners are wired fresh) automatically.
  function setUpColorGallerySync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var html = event && event.data && event.data.html;
      var sectionId = event && event.data && event.data.sectionId;
      if (!html || !sectionId) return;

      var sourceGallery = html.querySelector('media-gallery[data-color-gallery-override]');
      var destinationGallery = document.getElementById('MediaGallery-' + sectionId);

      // Whichever side (before/after the swap) is in override mode, a full replace is the only
      // way to guarantee the right images show — a color with no color_gallery value at all
      // falling back to the native per-variant path is exactly as real a transition as the
      // reverse, and updateMedia() only handles a destination that already has a real
      // featured_media.id, not one built from this override's own synthetic slide ids.
      var gallerySwapped =
        (sourceGallery || (destinationGallery && destinationGallery.hasAttribute('data-color-gallery-override'))) &&
        sourceGallery &&
        destinationGallery;

      // Only a *color* change should bring the shopper back to the first image. Picking a size
      // re-fetches the same section and used to rebuild the gallery just the same, throwing away
      // wherever they had swiped to — so skip the swap (gallery and modal) when the incoming
      // images are exactly the ones already showing.
      if (gallerySwapped && galleryImages(sourceGallery) === galleryImages(destinationGallery)) return;

      if (gallerySwapped) {
        destinationGallery.outerHTML = sourceGallery.outerHTML;
        var slider = document.querySelector('#MediaGallery-' + sectionId + ' slider-component');
        if (slider) setUpGallery(slider);
      }

      // Same override-mode gate as the gallery above, checked independently (rather than
      // reusing `gallerySwapped`) since the modal is looked up by its own id, not derived from
      // whichever gallery element the swap above already found.
      //
      // innerHTML, not outerHTML — this <product-modal> was already relocated to a direct child
      // of <body> by its own connectedCallback's one-time `this.moved` guard (assets/global.js)
      // the instant it first connected, at page load. An outerHTML swap builds a *second*
      // instance and re-triggers that same connectedCallback on it, but by then the element
      // being replaced lives under <body>, not under any `.shopify-section` — confirmed live: it
      // threw `Cannot read properties of null (reading 'id')` from `this.closest(
      // '.shopify-section').id`. Swapping just the content and re-wiring in place
      // (wireUpTrack — assets/product-modal.js) sidesteps that path entirely.
      var sourceModal = html.querySelector('#ProductModal-' + sectionId);
      var destinationModal = document.getElementById('ProductModal-' + sectionId);
      var modalWasOverride = destinationModal && destinationModal.querySelector('[data-media-id*="-color-gallery-"]');
      var modalIsOverride = sourceModal && sourceModal.querySelector('[data-media-id*="-color-gallery-"]');
      if (sourceModal && destinationModal && (modalWasOverride || modalIsOverride)) {
        destinationModal.innerHTML = sourceModal.innerHTML;
        if (typeof destinationModal.wireUpTrack === 'function') destinationModal.wireUpTrack();
      }
    });
  }

  // A gallery's identity for the comparison above: the image URLs in slide order.
  function galleryImages(gallery) {
    return Array.prototype.map
      .call(gallery.querySelectorAll('li[data-media-id] img'), function (img) {
        return img.getAttribute('src') || '';
      })
      .join('|');
  }

  // Material & care / Shipping & returns — custom trigger+panel (see the collapsible_tab case in
  // sections/main-product.liquid for why this isn't Dawn's stock <details>/<summary>: no smooth
  // height transition on a native <details> toggle). Delegated on the document since these blocks
  // don't get replaced by the variant-swap AJAX morph the way the buy row does, but delegation
  // costs nothing here and needs no re-wiring if that ever changes.
  function setUpAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pdp-accordion-trigger]');
      if (!trigger) return;
      var item = trigger.closest('[data-pdp-accordion]');
      if (!item) return;
      var isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Sold-out → notify-me toggles a `.is-sold-out` class on the stable panel wrapper (never itself
  // replaced by product-info.js's AJAX swap — see sections/main-product.liquid's own comment on
  // .ai-pdp-notify for why a bare CSS :has(:disabled) rule reacting to the submit button directly
  // doesn't work: that button is disabled for the entire duration of *every* variant swap as a
  // loading indicator, regardless of whether the eventual variant turns out to be available.
  //
  // A first version of this guessed at "loading vs. genuinely sold out" with a fixed debounce
  // timer (only counted as sold out once `disabled` had held continuously for 600ms). That's a
  // race against however long the variant-swap fetch actually takes — fine on a fast connection,
  // but a real bug report confirmed it: on a slower connection (or just a slower Shopify CDN
  // response) a fetch for a perfectly in-stock variant can take longer than any fixed guess,
  // which flips the timer's "sold out" verdict before the real answer arrives — visible as the
  // Notify-me panel opening, then immediately closing once the true (available) state lands a
  // moment later. No timeout value fixes this in general; the fetch can always be slower than
  // whatever number is picked.
  //
  // Fixed by not guessing at all: product-info.js already tells us exactly when a variant-select
  // fetch starts (PUB_SUB_EVENTS.optionValueSelectionChange, published synchronously the instant
  // the shopper picks a new option, before the fetch even starts) and — for the common case where
  // a matching variant exists — exactly when it's done and the button's disabled state is final
  // (PUB_SUB_EVENTS.variantChange, published only after handleUpdateProductInfo has already set
  // the real, resolved disabled state). Between those two events, every `disabled` mutation is
  // known to be the loading blip, not a verdict — so `check()` just no-ops instead of debouncing.
  // Once `variantChange` fires (or the FALLBACK_MS safety net, for the one path that doesn't
  // publish it — see settle() below), `check()` re-reads the now-final disabled state and applies
  // it immediately: no more waiting than the fetch itself actually took.
  //
  // Both the button and the notify-me markup live inside <product-info>, which product-info.js
  // wholesale replaces (new element inserted, old one removed — see HTMLUpdateUtility.
  // viewTransition in assets/global.js) on every swap, so nothing inside it can be queried once
  // and cached — the observer re-queries fresh from the stable panel ancestor on every check.
  function setUpNotifyDebounce() {
    // Safety net only, not the primary signal: product-info.js's setUnavailable() path (no variant
    // matches the selected option combination at all — no size/color combo this catalog's test
    // data actually has, but a real one a merchant could hit) disables the button without ever
    // publishing variantChange. Generous on purpose since it should essentially never fire in the
    // common case, unlike the old DEBOUNCE_MS which raced every single variant change.
    var FALLBACK_MS = 2500;

    document.querySelectorAll('.product__media-wrapper').forEach(function (mediaWrapper) {
      var panel = mediaWrapper.closest('[class*="ai-pdp__panel-"]');
      if (!panel || panel._cwNotifyWired) return;
      panel._cwNotifyWired = true;

      var pending = false;
      var fallbackTimer = null;

      function apply(isSoldOut) {
        panel.classList.toggle('is-sold-out', isSoldOut);
      }

      // While a variant-select fetch is in flight, the button's `disabled` attribute reflects
      // "loading," not availability — ignore every mutation until settle() says the real answer
      // is in. Outside that window (first paint, or once settled), it's authoritative.
      function check() {
        if (pending) return;
        var btn = panel.querySelector('.product-form__submit');
        // A button disabled only because every available unit is already in the cart
        // (assets/product-quantity-availability.js sets data-qty-blocked) is not "sold out" —
        // don't open the notify-me form for it.
        apply(!!(btn && btn.disabled && btn.dataset.qtyBlocked !== 'true'));
      }

      function settle() {
        pending = false;
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
        check();
      }

      // Real state, applied instantly on first paint — nothing has re-rendered yet to produce a
      // loading blip, so there's no window to guard against here.
      check();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
          if (!event?.data?.target || !panel.contains(event.data.target)) return;
          pending = true;
          clearTimeout(fallbackTimer);
          fallbackTimer = setTimeout(settle, FALLBACK_MS);
        });

        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var info = panel.querySelector('product-info');
          var sectionId = info && (info.dataset.originalSection || info.dataset.section);
          if (event?.data?.sectionId && sectionId && event.data.sectionId !== sectionId) return;
          settle();
        });
      }

      new MutationObserver(check).observe(panel, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    });
  }

  // Desktop: the media column must match the info column's real rendered height (Add to Cart +
  // description + accordions + share can add up to well past the photo's own natural height —
  // see the CSS comment on the `@media (min-width: 990px)` gallery-height rule in
  // sections/main-product.liquid for why a CSS-only `height: 100%` cascade couldn't do this: a
  // flex item's stretched cross-size isn't reliably "definite" enough for a descendant several
  // levels down to resolve a percentage height against, confirmed empirically here). Writing an
  // explicit inline px height onto `.product__media-wrapper` sidesteps that ambiguity entirely —
  // it's a real, unambiguous value the CSS `height: 100%` chain underneath it can cascade from
  // normally.
  //
  // The target is `info`'s own height, *exactly* — not padded/adjusted in any way. That's a
  // deliberate, load-bearing choice, not an oversight: .product__media-wrapper is a normal,
  // unbled flex item at this breakpoint (see the same CSS comment) — the panel's padding-flush
  // bleed lives one level deeper, on slider-component (position: absolute, inset by
  // -panel_padding on all four sides — see main-product.liquid). Padding the *wrapper's* own
  // height here would be circular: the wrapper is also the row's tallest item, so inflating it
  // inflates the row (and the panel) by the same amount, forever — proven both algebraically and
  // empirically while landing on this fix (a stable, un-closeable gap that tracked whatever
  // padding math was tried, no matter the value). Matching info's height exactly keeps the
  // wrapper (and therefore the row, and therefore the panel) sized from info alone; the
  // absolutely-positioned, out-of-flow slider-component is what actually reaches the panel's
  // true edges, contributing nothing back to any of those sizes.
  //
  // Re-measured on: initial load (+ one rAF later, since a webfont swap can still reflow the info
  // column's text height after this script's first run), window resize, the info column's own
  // size changing for any reason (ResizeObserver — covers accordion open/close, a variant swap
  // landing on a longer/shorter description, anything), and after every variant-swap AJAX
  // re-render (product-info.js wholesale-replaces the whole <product-info> element, which would
  // otherwise silently orphan the ResizeObserver's target).
  function syncMediaHeightToInfoColumn() {
    // Must match sections/main-product.liquid's own `.product__media-wrapper` breakpoint exactly
    // (990px, not Dawn's stock 750px tablet breakpoint) — that's the width Dawn's own `.product--
    // large/medium/small` rules actually switch media/info to a side-by-side row at (see the CSS
    // comment on that rule); below it `.product` stays stacked regardless of this section's own
    // media_size setting, so writing an inline height here at any narrower width would fight the
    // single-column layout instead of matching a row that doesn't exist yet.
    var mql = window.matchMedia('(min-width: 990px)');
    var resizeObservers = new WeakMap();

    function applyHeight(panel) {
      var media = panel.querySelector('.product__media-wrapper');
      var info = panel.querySelector('.product__info-wrapper');
      if (!media) return;
      if (!mql.matches || !info) {
        media.style.removeProperty('height');
        return;
      }
      var current = parseFloat(media.style.height) || 0;
      // Reset before measuring, not just before writing: `info`'s own rendered height can be
      // influenced by whatever height media currently carries from a *previous* call. Clearing
      // media's inline height first means every measurement starts from the same clean baseline
      // instead of compounding whatever the last call wrote.
      media.style.removeProperty('height');
      var target = info.getBoundingClientRect().height;
      // Belt-and-suspenders against the feedback loop the `align-items: flex-start` CSS rule
      // (sections/main-product.liquid, same @media block) already fixes at the root: skip the
      // write entirely when it wouldn't meaningfully change anything, so even a sub-pixel
      // rounding oscillation between the ResizeObserver and this write can't sustain a loop.
      if (Math.abs(target - current) < 1) {
        media.style.height = current + 'px';
        return;
      }
      media.style.height = target + 'px';
    }

    function observeInfo(panel) {
      var info = panel.querySelector('.product__info-wrapper');
      if (!info) return;
      var existing = resizeObservers.get(panel);
      if (existing) existing.disconnect();
      var ro = new ResizeObserver(function () {
        applyHeight(panel);
      });
      ro.observe(info);
      resizeObservers.set(panel, ro);
    }

    document.querySelectorAll('[class*="ai-pdp__panel-"]').forEach(function (panel) {
      applyHeight(panel);
      observeInfo(panel);
      requestAnimationFrame(function () {
        applyHeight(panel);
      });

      new MutationObserver(function () {
        applyHeight(panel);
        observeInfo(panel);
      }).observe(panel, { childList: true, subtree: true });
    });

    mql.addEventListener('change', function () {
      document.querySelectorAll('[class*="ai-pdp__panel-"]').forEach(applyHeight);
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[class*="ai-pdp__panel-"]').forEach(applyHeight);
      }, 100);
    });
  }

  // The actual source of the page jumping to the gallery on every variant change turned out not
  // to be MediaGallery's own scrollTo above (confirmed empirically — it never fired in testing)
  // but a separate, more fundamental browser behavior: product-info.js's renderProductInfo
  // re-focuses the clicked swatch input by id once the variant-swap fetch resolves
  // (`document.querySelector('#' + targetId)?.focus()`) — a real, deliberate accessibility
  // behavior (keeps keyboard/screen-reader focus on the option the shopper just picked, since the
  // AJAX re-render replaces the whole DOM subtree with fresh elements). `Element.prototype.focus`
  // scrolls its target into view by default unless called with `{preventScroll: true}`, which
  // Dawn's call doesn't pass — that's the jump. Can't change which options that stock call passes
  // without forking the file, so `focus` itself is stubbed to always add `preventScroll: true`,
  // but only for a short bounded window around each variant swap (armed on every 'change' event
  // from a variant radio/select, disarmed ~1.5s later — comfortably past normal fetch latency)
  // rather than for the page's entire lifetime, so it can't suppress an unrelated, genuinely
  // wanted focus-scroll (e.g. opening the cart drawer) happening at some unrelated moment.
  function suppressFocusScrollOnVariantChange() {
    var realFocus = HTMLElement.prototype.focus;
    var armed = false;
    var disarmTimer = null;

    HTMLElement.prototype.focus = function (options) {
      if (armed) {
        options = Object.assign({}, options, { preventScroll: true });
      }
      return realFocus.call(this, options);
    };

    function arm() {
      armed = true;
      clearTimeout(disarmTimer);
      disarmTimer = setTimeout(function () {
        armed = false;
      }, 1500);
    }

    document.querySelectorAll('variant-selects').forEach(function (el) {
      el.addEventListener('change', arm);
    });
  }

  function setUpGallery(slider) {
    setUpDots(slider);
    setUpDragToScroll(slider);
    setUpSnapCorrection(slider);
  }

  // Belt-and-suspenders for real touch swipes on phones: CSS `scroll-snap-type: x mandatory` +
  // `scroll-snap-stop: always` (sections/main-product.liquid) is supposed to guarantee the track
  // always comes to rest exactly on a slide, but this particular gallery is a much heavier page
  // than the site's other swipe tracks (product-carousel.liquid, community.liquid, etc, none of
  // which wrap Dawn's own <slider-component>/<media-gallery> custom elements or run the
  // ResizeObserver/MutationObserver pair in syncMediaHeightToInfoColumn above) — enough extra
  // main-thread work during a swipe that a real device can occasionally still let the native
  // snap settle a few px short of the slide boundary, leaving a sliver of the previous slide
  // visible instead of the next one filling the frame. Rather than chase that timing bug further,
  // this just corrects it after the fact: once scrolling has actually stopped, snap the track to
  // whichever slide boundary it ended up nearest to, instantly (no visible extra motion since
  // it's only ever a few px). `scrollend` (modern browsers, including iOS 17+ Safari) fires
  // exactly once when a scroll — native swipe or programmatic — truly finishes; the older
  // `scroll` + debounce fallback approximates the same "scrolling has stopped" moment for
  // anything without it.
  function setUpSnapCorrection(slider) {
    var track = slider.slider;
    if (!track) return;

    function correct() {
      var items = slider.sliderItemsToShow;
      if (!items || items.length < 2) return;
      var itemWidth = items[1].offsetLeft - items[0].offsetLeft;
      if (!itemWidth) return;
      var nearest = Math.round(track.scrollLeft / itemWidth) * itemWidth;
      nearest = Math.max(0, Math.min(nearest, track.scrollWidth - track.clientWidth));
      if (Math.abs(track.scrollLeft - nearest) > 1) {
        track.scrollTo({ left: nearest, behavior: 'instant' });
      }
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', correct);
    } else {
      var settleTimer = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(correct, 120);
      });
    }
  }

  // Dawn's own MediaGallery.setActiveMedia (assets/media-gallery.js) does two scrolls whenever a
  // variant swap changes the active image: a horizontal one to bring the matching slide into
  // view inside the gallery track (element.scrollTo — wanted, keeps working untouched below), and
  // a *vertical* one that scrolls the whole page up to the gallery if it's above the viewport
  // (window.scrollTo — not wanted here: picking a color shouldn't yank the page around, the
  // shopper can already see their own selection change in the swatch itself and will scroll to
  // the photo on their own if they want to). No hook exists to opt out of just the second one, and
  // the two scrolls are two different DOM methods (Element.prototype.scrollTo vs.
  // Window.prototype.scrollTo) — so window.scrollTo is stubbed out for the single tick Dawn's own
  // method runs in (it's called from inside a window.setTimeout, a macrotask, which is why a
  // short delayed restore is enough), rather than patching setActiveMedia itself apart byte for
  // byte. Wrap-and-restore, not a fork of Dawn's file.
  function suppressAutoScrollToMedia() {
    if (!window.customElements || !customElements.get) return;
    customElements.whenDefined('media-gallery').then(function () {
      var proto = customElements.get('media-gallery').prototype;
      var original = proto.setActiveMedia;
      if (!original || proto._cwScrollSuppressed) return;
      proto._cwScrollSuppressed = true;
      proto.setActiveMedia = function (activeMediaId) {
        // Same featured image as before (e.g. only the size changed): leave the gallery exactly
        // where the shopper swiped it. Only a different featured image — a color change —
        // brings the gallery back to its first slide.
        var currentViewer = this.elements && this.elements.viewer;
        var currentActive = currentViewer && currentViewer.querySelector('[data-media-id].is-active');
        if (currentActive && activeMediaId && currentActive.dataset.mediaId === activeMediaId) return;

        // Color-gallery override slides carry synthetic ids (`…-color-gallery-N`), never the
        // variant's native featured_media id, so Dawn's lookup misses and falls back to the
        // first slide — snapping the gallery back to image 1 on every size change. A color
        // change replaces the whole gallery (setUpColorGallerySync) and starts at slide 1 anyway.
        if (viewerLacksMedia(currentViewer, activeMediaId)) return;

        var realScrollTo = window.scrollTo;
        window.scrollTo = function () {};
        var result = original.apply(this, arguments);
        setTimeout(function () {
          window.scrollTo = realScrollTo;
        }, 100);

        // Dawn's own horizontal scrollTo (the "wanted" one this whole wrapper otherwise leaves
        // untouched) only runs when `!this.mql.matches || this.elements.thumbnails` — true on
        // mobile, or on desktop *if* a thumbnail rail exists (assets/media-gallery.js). This
        // gallery forces the same horizontal scroll-snap track at every breakpoint (see the
        // "Horizontal swipe gallery" comment in main-product.liquid) and never renders
        // thumbnails, so on desktop that condition is always false: the variant's photo still
        // swaps in the DOM (Dawn reorders it to the front, unconditionally), but the track's own
        // scroll position was never told to follow it, so the shopper kept seeing whichever photo
        // used to be scrolled into view. Scrolled here instead, unconditionally, reusing the
        // `.is-active` element Dawn's own call above already picked.
        var viewer = this.elements && this.elements.viewer;
        var activeMedia = viewer && viewer.querySelector('[data-media-id].is-active');
        if (activeMedia && activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
        }

        return result;
      };
    });
  }

  function viewerLacksMedia(viewer, mediaId) {
    return !!(viewer && mediaId && !viewer.querySelector('[data-media-id="' + mediaId + '"]'));
  }

  function setUpDots(slider) {
    var dotsWrap = slider.parentElement.querySelector('[data-gallery-dots]');
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('[data-gallery-dot]');
    if (!dots.length) return;

    slider.addEventListener('slideChanged', function (e) {
      var index = (e.detail.currentPage || 1) - 1;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var track = slider.slider;
        var targetSlide = slider.sliderItemsToShow && slider.sliderItemsToShow[i];
        if (!track || !targetSlide) return;
        track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      });
    });
  }

  // Native scroll-snap already gives real touch swipe on phones and two-finger swipe on trackpads
  // — this only adds click-and-drag for a plain desktop mouse, which has no touch gesture of its
  // own. Suppresses the click that would otherwise fire on the image's zoom-modal opener at the
  // end of a drag (a real click still opens the modal; a drag never does).
  function setUpDragToScroll(slider) {
    var track = slider.slider;
    if (!track) return;

    var isPointerDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // real touch already scrolls natively
      isPointerDown = true;
      didDrag = false;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (!isPointerDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 4) didDrag = true;
      track.scrollLeft = startScrollLeft - delta;
    });

    function endDrag() {
      if (!isPointerDown) return;
      isPointerDown = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );
  }
})();
